<div id="body-container">

  <div class="background-blue" *ngIf="!isOnboardingFlow">
    <div class="page-title-container container">
      <h1 style="font-size:22.5px;"><adp-label labelKey="RegisterNumber_PageTitle"></adp-label></h1>
    </div>
  </div>

  <ng-container>

    <div class="back container pt-4" style="display:flex;" *ngIf="!isAdditionalDeviceFlow">

          <div style="white-space: nowrap;">
            <button class="link" (click)="handleBack()" style="padding-left:0px;"><mat-icon
              style="padding-top:6px;">keyboard_arrow_left</mat-icon>{{backLabel}}</button>
          </div>
          <div style="width:100%;"></div>
          <div style="white-space: nowrap;" *ngIf="state != states.TextMessage">
            <button class="link" (click)="goToDashboard()" style="padding-left:0px;padding-top:8px;"><adp-label labelKey="Global_Button_Dashboard"></adp-label></button>
          </div>
    </div>

    <div class="back container pt-4" style="display:flex;" *ngIf="isAdditionalDeviceFlow">
      <div *ngIf="isBackVisible" style="white-space: nowrap;">
        <button class="link" (click)="handleBack()" style="padding-left:0px;"><mat-icon
          style="padding-top:6px;">keyboard_arrow_left</mat-icon><adp-label labelKey="Global_Button_Back"></adp-label></button>
      </div>
      <div style="width:100%;"></div>
      <div style="white-space: nowrap;">
        <button class="link" (click)="goToDashboard()" style="padding-left:0px;padding-top:8px;"><adp-label labelKey="Global_Button_Dashboard"></adp-label></button>
      </div>
    </div>


    <div class="container phone-registration-page">
      <pgh-register-number *ngIf="state === states.RegisterNumber"
        (registerPhoneNumberEvent)="handleRegisterPhoneNumber()"
        (nextEvent)="goToTextScreen({'phoneNumber': $event,'state' : states.TextMessage})" [isOnboardingFlow]="isOnboardingFlow"></pgh-register-number>

      <pgh-text-message *ngIf="state === states.TextMessage" [phoneNumber]="phoneNumber" [isOnboardingFlow]="isOnboardingFlow" [isAdditionalDeviceFlow]="isAdditionalDeviceFlow"></pgh-text-message>
    </div>
    <div *ngIf="!isOnboardingFlow" style="margin-bottom:100px;"></div>
  </ng-container>
</div>
